import { PropsWithChildren, useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "./authContext/AuthContext";
import { isEmailInAllowlist } from "../../helpers/emailAllowlist.helpers";

type Props = PropsWithChildren<{
  allowedEmails: readonly string[];
  redirectTo?: string;
}>;

/** Requires an authenticated user whose email is in `allowedEmails`. */
function PrivateRouteEmailAllowlist({
  children,
  allowedEmails,
  redirectTo = "/",
}: Props) {
  const { auth } = useContext(AuthContext);
  const email = auth?.user?.email;

  if (!isEmailInAllowlist(email, allowedEmails)) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
}

export default PrivateRouteEmailAllowlist;
